"use client";

import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Link as ScrollLink } from 'react-scroll';
import Image from 'next/image';

const Navbar = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const pathname = usePathname();

  const getNavbarColor = () => {
    if (pathname === "/") return "bg-transparent";
    return 'bg-brand-green/95';
  };
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: t("navbar.home"), to: "hero" },
    { label: t("navbar.news"), to: "news" },
    { label: t("navbar.region"), to: "region" },
    { label: t("navbar.territory"), to: "territory" },
    { label: t("navbar.governance"), to: "organization" },
    { label: t("navbar.associates"), to: "associates" },
    { label: t("navbar.contact"), to: "footer" },
  ];

  const isHomePage = pathname === "/";

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 
    ${isScrolled ? 'bg-brand-green/95 shadow-lg' : `${getNavbarColor()} py-2`}`
  }>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Link href="/" className="flex items-center">
          <Image 
            src="/images/Logo-RV-01.png"
            alt="Logo"
            width={1505}
            height={1351}
            className="h-28 w-auto object-contain" 
          />
          {/* <span className="flex items-center text-white font-bold text-xl px-2">
            Cafés da Região Vulcânica
          </span> */}
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          {navItems.map((item) => (
            isHomePage ? (
              <ScrollLink
                key={item.to}
                to={item.to}
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                className="text-white hover:text-gray-300 transition-colors cursor-pointer"
              >
                {item.label}
              </ScrollLink>
            ) : (
              <Link
                key={item.to}
                href={`/#${item.to}`}
                className="text-white hover:text-gray-300 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-brand-green shadow-lg">
          <div className="container mx-auto px-6 py-4">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                isHomePage ? (
                  <ScrollLink
                    key={item.to}
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                    className="text-white hover:text-green-300 transition-colors cursor-pointer py-2"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </ScrollLink>
                ) : (
                  <Link
                    key={item.to}
                    href={`/#${item.to}`}
                    className="text-white hover:text-green-300 transition-colors cursor-pointer py-2"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
